// extracted by mini-css-extract-plugin
module.exports = {"root":"FileUploadToAws-module__root__2Khyo","read-only":"FileUploadToAws-module__read-only__2Vk7n","disabled-style":"FileUploadToAws-module__disabled-style__1R_Yr"};